import { objectWithoutProperties as _objectWithoutProperties, toConsumableArray as _toConsumableArray, slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import ButtonIcon from '../Inputs/Button/ButtonIcon/ButtonIcon.js';
import useRect from '../../hooks/useRect.js';
import Flyout from '../Flyout/index.js';
import { DEFAULT_PLACEMENT_OPTIONS } from '../Flyout/Flyout.constants.js';

var _excluded = ["children", "dependencies", "disableScrollWhenOpen", "displayBackdrop", "isOpen", "onOutsideClick", "placement", "testId", "title"];
var ButtonWithFlyout = function ButtonWithFlyout(_ref) {
  var children = _ref.children,
    _ref$dependencies = _ref.dependencies,
    dependencies = _ref$dependencies === void 0 ? [] : _ref$dependencies,
    _ref$disableScrollWhe = _ref.disableScrollWhenOpen,
    disableScrollWhenOpen = _ref$disableScrollWhe === void 0 ? true : _ref$disableScrollWhe,
    _ref$displayBackdrop = _ref.displayBackdrop,
    displayBackdrop = _ref$displayBackdrop === void 0 ? false : _ref$displayBackdrop,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$onOutsideClick = _ref.onOutsideClick,
    onOutsideClick = _ref$onOutsideClick === void 0 ? function () {} : _ref$onOutsideClick,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? undefined : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useRect = useRect(100, [].concat(_toConsumableArray(dependencies), [isOpen])),
    _useRect2 = _slicedToArray(_useRect, 2),
    ref = _useRect2[0],
    rect = _useRect2[1];
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ButtonIcon, _extends({
    ref: ref
  }, props, {
    title: title,
    testId: testId ? "".concat(testId, "-button") : undefined
  }), title), isOpen && React__default.createElement(Flyout, {
    disableScrollWhenOpen: disableScrollWhenOpen,
    displayBackdrop: displayBackdrop,
    isPortalAlwaysOnScreen: true,
    isPortalClosedOnResize: true,
    onOutsideClick: onOutsideClick,
    placement: placement,
    testId: testId,
    triggerPosition: rect
  }, children));
};
ButtonWithFlyout.propTypes = _objectSpread2(_objectSpread2({}, ButtonIcon.propTypes), {}, {
  children: PropTypes.node.isRequired,
  dependencies: PropTypes.array,
  disableScrollWhenOpen: PropTypes.bool,
  displayBackdrop: PropTypes.bool,
  isOpen: PropTypes.bool,
  onOutsideClick: PropTypes.func,
  placement: PropTypes.oneOf(Object.keys(DEFAULT_PLACEMENT_OPTIONS)),
  testId: PropTypes.string,
  title: PropTypes.string
});
var ButtonWithFlyout$1 = ButtonWithFlyout;

export { ButtonWithFlyout$1 as default };
//# sourceMappingURL=ButtonWithFlyout.js.map
